<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <div class="row">
      <div class="col-xl-12">
        <div class="dash-head-wrap d-flex justify-content-between align-items-center">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Skill Certificates <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
            </h2>
            <!-- <p class="text-secondary">let's dive into your personalized setup guide.</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="card top-cardheader">
      <div class="row m-0">
        <div class="col-xl-6 col-md-6 p-0">
          <!--                    <router-link class="nav-item" to="/company_locations">-->
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewActiveCertificateIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3
                                    ">
                <h5 class="font-weight-normal m-0" name="New employee">Active Certificates</h5>
                <span name="New employee">{{ active_cer }}</span>

              </div>

            </div>
          </div>
          <!--                    </router-link>-->
        </div>
        <div class="col-xl-6 col-md-6 p-0">
          <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewExpiredCertificateIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0">Expired Certificates</h5>
                <span>{{ expire_cer }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company_certificate_wrap">
      <div>
        <card class="no-border-card card-with-table" footer-classes="pt-1">
          <div class="row justify-content-sm-between flex-wrap location-form mb-4 px-4">
            <div class="col-md-6 col-lg-6 col-xl-7 d-flex align-items-center search-style">
              <h2 class="mb-2">Certificates</h2>
            </div>
            <div class="col-md-6 col-lg-6 col-xl-3 d-flex select-with-dynamic-class select-style mb-3 mb-md-0">
              <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Search..."
                class="search-style w-100 flex-wrap">
              </base-input>
            </div>
          </div>
          <div>
            <!-- Additional Courses Section -->
            <div class="additional-section">
              <!-- <h3 class="ml-4">Additional Certificates</h3> -->
              <div class="user-eltable table-style-normal no-header-bg">
                <!-- :data="additionalCourses" -->
                <el-table :data="additionalCourses" row-key="id" role="table" class="certificateGrid"
                  header-row-class-name="thead-light custom-thead-light" @sort-change="sortChange"
                  @selection-change="selectionChange">
                  <el-table-column align="left" min-width="90px" label="Course Name" class-name="ignore-translation">
                    <template slot-scope="props">
                      <router-link :to="'/certificate_details?id=' +
                        props.row.id +
                        '&course=' +
                        props.row.course_id +
                        '&folder=' +
                        props.row.is_folder
                        ">
                        <span>{{ props.row.course_name }}</span>
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column align="left" min-width="200px" label="# of active certificates">
                    <template slot-scope="props">
                      <span>{{ props.row.user_count }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Action" min-width="70px">
                    <template slot-scope="props">
                      <router-link :to="'/certificate_details?id=' +
                        props.row.id +
                        '&course=' +
                        props.row.course_id +
                        '&folder=' +
                        props.row.is_folder
                        ">
                        <base-button name="Certificate Details" type="primary" outline="true" class="py-2 px-4"
                          size="sm">
                          Details
                        </base-button>
                      </router-link>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
//import swal from 'sweetalert';
import Swal from "sweetalert2";
let timeout = null;
export default {
  mixins: [clientPaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      loading: false,
      searchQuery: "",
      company_name: "",
      hot_user: "",
      hot_token: "",
      user_id: "",
      config: "",
      certificateStatus: [
        {
          label: "My Certificates",
          value: "Company"
        },
        {
          label: "Employee Certificates",
          value: "Employee"
        }
      ],
      filters: {
        certStatus: "Employee"
      },
      locationManager: false,
      location_id: "",
      tableData: [],
      selectedRows: [],
      total_cer: '',
      active_cer: '',
      expire_cer: '',
      upload_cer: '',
      is_active_show: true,
      is_expired_show: false,
      is_uploaded_show: false,
      complianceCourses: [],
      additionalCourses: [],
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig";
    },
    overviewActiveCertificateIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/active_certificate.svg")
        : "img/svg-icons/active_certificate.svg";
    },
    overviewExpiredCertificateIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/expired_certificate.svg")
        : "img/svg-icons/expired_certificate.svg";
    },
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
      this.user_id = localStorage.getItem("hot-user-id");
      this.company_name = localStorage.getItem("hot-company-name");
    }
    if (localStorage.getItem("hot-sidebar") === "location_manager") {
      this.locationManager = true;
      this.location_id = localStorage.getItem("hot-location-id");
    }
    this.fetchData();
    // this.certificateCountCheck();
  },
  watch: {
    searchQuery: function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http
        .post("course/certificatesList", {
          search: this.searchQuery
        })
        .then(resp => {
          let certificates = resp.data.certificates;
          let certificatefolders = resp.data.certificatefolders;

          let complianceCourses = [];
          let otherCourses = [];

          // Process certificates
          for (let certificate of certificates) {
            let obj = {
              id: certificate.id,
              is_folder: 0,
              course_id: certificate.course_id,
              certificate_name: certificate.certificate_name,
              course_name: certificate.course_name,
              user_count: certificate.employee_count,
              certificate_count: certificate.certificate_count,
              course_type: certificate.course_type
            };
            // if (certificate.course_type == 1) {
            //     complianceCourses.push(obj);
            // } else {
            otherCourses.push(obj);
            // }
          }

          // Process certificate folders
          for (let certificatefolder of certificatefolders) {
            let obj1 = {
              id: certificatefolder.id,
              is_folder: 1,
              course_id: certificatefolder.course_id,
              certificate_name: certificatefolder.certificate_name,
              course_name: certificatefolder.course_name,
              user_count: certificatefolder.employee_count,
              certificate_count: certificatefolder.certificate_count,
              course_type: certificatefolder.course_type
            };
            // if (certificatefolder.course_type == 1) {
            //     complianceCourses.push(obj1);
            // } else {
            otherCourses.push(obj1);
            // }
          }

          // Sort both arrays alphabetically by course_name
          // complianceCourses.sort((a, b) => a.course_name.localeCompare(b.course_name));
          otherCourses.sort((a, b) => a.course_name.localeCompare(b.course_name));

          // Assign to separate data properties
          this.complianceCourses = complianceCourses;
          // this.additionalCourses = otherCourses;
          this.additionalCourses = otherCourses;
          this.active_cer = resp.data.total_active_certificates
          this.expire_cer = resp.data.total_expired_certificates
        })
        .finally(() => (this.loading = false));
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}


.user-eltable .el-table__row .cell {
  width: auto !important;
}

@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .certificateGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "Course Name";
  }

  .certificateGrid>>>table.el-table__body td:nth-of-type(2) .cell {
    width: 150px
  }

  .certificateGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "# of active certificates";
  }

  .certificateGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Action";
  }
}

.search-style>>>.form-group {
  width: 100%;
  display: block;
}
</style>
